import { useSelector } from 'react-redux';
import constVars from '~/constants/constVars';
import { marketSupportsSvcOnboardingAuth } from '~/constants/markets';
import { RootState } from '~/store';

export const useShouldUseSvcOnboardingAuth = () => {
  const market = useSelector((state: RootState) => state.intl.market);
  const pathname = window.location.pathname;

  const isCreatePasscodeDonePage = pathname.includes(
    constVars.ROUTE_CREATE_PASSCODE_DONE
  );
  // Needs no auth of its own — this stops it from re-running WebID
  // identification against an already-used reset link on every load.
  if (isCreatePasscodeDonePage) return false;

  return marketSupportsSvcOnboardingAuth(market, pathname);
};
